import React from 'react';
import ReactDOM from 'react-dom';

import type { Initializer } from 'common/types/initializers';
import { Reconnect } from 'src/federation/Reconnect';
import { getOrAppendChild } from 'utilities/DOM/getOrAppendChild';

import type { SharedProps } from 'reconnect-types/moduleFederation';

export const ClientOverviewInitializer = (
  props: Pick<
    SharedProps['ClientOverview'],
    'clientId' | 'onClose' | 'initialScreen' | 'accessedFrom'
  >,
): Initializer => {
  const node = getOrAppendChild({
    id: 'client-overview',
    parentNode: document.body,
  });

  const destroy = () => ReactDOM.unmountComponentAtNode(node);
  const onClose = () => {
    props.onClose();
    destroy();
  };

  return {
    destroy: () => ReactDOM.unmountComponentAtNode(node),
    render: () => {
      ReactDOM.render(
        <Reconnect
          name="ClientOverview"
          props={{
            onClose,
            clientId: props.clientId,
            notifyFn: Wahanda.ToastNotifications.sendMessage,
            canEditClientContactDetails: Wahanda.Permissions.editClientContactDetails(),
            initialScreen: props.initialScreen,
            accessedFrom: props.accessedFrom,
          }}
        />,
        node,
      );
    },
  };
};
